import React, { Component } from 'react';
import { Redirect } from "react-router";
import { withTranslation } from "react-i18next";
import ContactsForm from "../Parts/ContactsForm";
import Loading from "../Parts/Loading";
import ErrorAlert from "../../../components/UI/ErrorAlert";
import { APP_STEP_INCOMES } from "../../../constants";

class InitEshopProcess extends Component {
    constructor(props) {
        super(props);

        const {match: {params}} = this.props;

        this.state = {
            is_eshop: true,

            token: params.token,
            emodule_data: null,
            eshop_data: null,
            loading: true,
            redirectToConsentStep: false,
            loadingContactsForm: true,
        };

        this.formSubmit = this.formSubmit.bind(this);
        this.getLastStep = this.getLastStep.bind(this);
        this.loadEmoduleData();
        this.getLastStep();
    }

    loadEmoduleData() {
        axios.get('/api/eshop/' + this.state.token + '/get_emodule_data')
            .then(
                data => {
                    this.setState({eshop_data: data.data, loadingContactsForm: false});
                },
                error => {
                    this.setState({loadingContactsForm: false})
                }
            )
    }

    getLastStep()
    {
        axios.get('/api/eshop/' + this.state.token + '/last_step')
            .then(
                data => {
                    if (data.data.data?.last_step === APP_STEP_INCOMES) {
                        this.setState({
                            redirectToConsentStep: true,
                            loadingContactsForm: false,
                        });
                    }
                    this.setState({loading: false});
                },
                error => {
                    this.setState({loading: false});
                })
            .catch((a, b, c) => {
                console.log(a, b, c);
                this.setState({loading: false});
            });
    }

    formSubmit(values, actions) {
        axios.post('/api/eshop/' + this.state.token + '/process_init_form', values)
            .then(data => {
                    actions.setSubmitting(false);
                    if (data.data.status === 'success') {
                        this.setState({redirectToConsentStep: true});
                    }
                },
                error => {
                    let response_data = error.response.data;
                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                    actions.setStatus({
                        msg: response_data.message,
                        code: response_data.code,
                    });
                })
    }

    handleFFChange = event => {
        this.setState({knows_about_future_financial_changes: event.target.value});
    };

    render() {
        if (this.state.redirectToConsentStep) {
            return (
                <Redirect push={true} to={'/' + this.state.token + '/process/consent'}/>
            )
        }

        return (
            <div>

                <div className="container">
                    <ErrorAlert/>
                </div>

                {this.state.eshop_data && !this.state.loadingContactsForm &&
                <ContactsForm
                    suggestion={this.state}
                    data={{
                        first_name: this.state.eshop_data.client_first_name,
                        last_name: this.state.eshop_data.client_last_name,
                        email: this.state.eshop_data.client_email,
                        phone: this.state.eshop_data.client_phone,
                        personal_code: this.state.eshop_data.client_pers_code,
                        incomes: '',
                        bonus_code: '',
                        amount_cl: '',
                        amount_mortgage: '',
                        amount_other: '',
                        knows_about_future_financial_changes: false,
                    }}
                    loading={false}
                    submitFunction={this.formSubmit}
                    handleFFChange={this.handleFFChange}
                />
                }

                {this.state.loadingContactsForm &&
                <div className="row py-5">
                    <div className="container frame py-5">
                        <Loading
                            msg={this.props.t('waiting_for_eshop_data')}
                        />
                    </div>
                </div>
                }
            </div>
        )
    }
}

export default withTranslation()(InitEshopProcess);
